/** Decimal units (1 GB = 1000 MB), like traffic is usually billed. */
export function formatMB(mb: number): string {
  if (mb < 1000) return `${mb.toFixed(1)} MB`;
  const gb = mb / 1000;
  if (gb < 100) return `${gb.toFixed(2)} GB`;
  if (gb < 1000) return `${gb.toFixed(1)} GB`;
  return `${(gb / 1000).toFixed(3)} TB`;
}

export function formatDuration(sec: number): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(Math.floor(sec / 3600))}:${p(Math.floor((sec % 3600) / 60))}:${p(sec % 60)}`;
}

export const mbps = (v?: number) => (v === undefined ? '—' : `${v.toFixed(1)} Mbps`);
export const secs = (v?: number) => (v === undefined ? '—' : `${v.toFixed(1)} s`);

/**
 * A delay in seconds, as short as it stays readable: 0.14 s, 4.5 s, 12 s.
 * The caller adds "≈" where the number is an estimate (docs/m15-live-stats.md 2).
 */
export function delaySec(ms: number): string {
  const s = Math.max(0, ms) / 1000;
  if (s < 1) return `${s.toFixed(2)} s`;
  if (s < 10) return `${s.toFixed(1)} s`;
  return `${Math.round(s)} s`;
}

/** Backlog of the encoder: "0 s" while it keeps up, else tenths. */
export function backlogSec(ms: number): string {
  const s = Math.max(0, ms) / 1000;
  return s < 0.05 ? '0 s' : `${s.toFixed(1)} s`;
}

export const LANG: Record<string, string> = {
  en: 'English', es: 'Spanish', pt: 'Portuguese', de: 'German', fr: 'French', tl: 'Tagalog',
};

/**
 * Where a stream came in, as the user may read it (node-group.md §8, GROUP-UI NG-05): a member
 * of a node group is its group (us-east-1), never the member; another node is its name and region.
 */
export function serverName(node: { name: string; region?: string; group?: string }, withRegion = true): string {
  if (node.group) return node.group;
  return withRegion && node.region ? `${node.name} · ${node.region}` : node.name;
}
